module.exports = __webpack_public_path__ + "static/media/teen-burger-desktop-399_fr.e3741c60.jpg";